<template>
  <div>
    <v-dialog :value="true" scrollable persistent :max-width="maxWidth">
      <v-card>
        <v-card-title class="primary modal-title py-0">
          <span>Visualizar
            <span v-if="itemVisualizando.tipo==='ESCLARECIMENTO'">Esclarecimento</span>
            <span v-else>Impugnação</span>
          </span>
          <v-spacer/>
          <v-btn icon @click="fecharModal">
            <v-icon size="20" color="white">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="card-text-visualizar-esc-imp">
          <v-layout row wrap>
            <v-flex xs3 sm3 d-flex>
              <div class="az-text">
                <label class="label">Data</label>
                <div>{{itemVisualizando.dataCadastro | az-date('DD/MM/YYYY HH:mm')}}</div>
              </div>
            </v-flex>
            <v-flex xs5 sm5 d-flex>
              <div class="az-text">
                <label v-if="!itemVisualizando.tipoPessoa" class="label" >Empresa</label>
                <label v-else-if="itemVisualizando.tipoPessoa === 'F'" class="label" >Nome</label>
                <label v-else class="label">Empresa</label>
                <div v-if="itemVisualizando.fornecedor">{{ itemVisualizando.fornecedor.razaoSocial }}</div>
                <div v-else>{{itemVisualizando.nomeRazaoSocial}}</div>
              </div>
            </v-flex>
            <v-flex xs4 sm4 d-flex>
              <div class="az-text">
                <label class="label">Situação</label>
                <div>{{itemVisualizando.situacao | azEnum(situacoesEsclarecimentoImpugnacao)}}</div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="itemVisualizando.tipoPessoa">
            <v-flex xs3 sm3 d-flex>
              <div class="az-text">
                <label v-if="itemVisualizando.tipoPessoa === 'F'" class="label">CPF</label>
                <label v-else class="label">CNPJ</label>
                <div>{{itemVisualizando.cpfCnpj}}</div>
              </div>
            </v-flex>
            <v-flex xs4 sm4 d-flex>
              <div class="az-text">
                <label class="label">E-mail</label>
                <div>{{itemVisualizando.email}}</div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12 d-flex>
              <div class="az-text">
                <!-- TODO criar enum de front-->
                <label class="label">Assunto {{itemVisualizando.tipo.charAt(0).toUpperCase() + itemVisualizando.tipo.slice(1).toLowerCase()}}</label>
                <div>{{itemVisualizando.assunto}}</div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12 d-flex>
              <div class="az-text">
                <label class="label">Anexo</label>
                <div v-if="itemVisualizando.arquivoUri" class="anexos-esc-imp">
                  <a :href="criarLinkDownload(itemVisualizando.arquivoUri)"
                     class="anexo-esc-imp az-action-link-icon" target="_blank"
                     @click="verificarUriAnexo(itemVisualizando.arquivoUri)">
                    {{itemVisualizando.arquivoNome}} <v-icon size="20px">download</v-icon>
                  </a>
                </div>
                <div v-else class="sem-anexos-esc-ipm">
                  <v-icon size="20">info</v-icon>
                  <span v-if="itemVisualizando.tipo === 'ESCLARECIMENTO'">
                    Este esclarecimento não possui anexos
                  </span>
                      <span v-else>
                    Esta impugnação não possui anexos
                  </span>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-divider></v-divider>
          </v-layout>
          <v-layout row wrap>
            <v-flex class="pb-2">
              <div class="az-text">
                <!-- TODO criar enum de front-->
                <label class="label">Respostas {{itemVisualizando.tipo.charAt(0).toUpperCase() + itemVisualizando.tipo.slice(1).toLowerCase()}}</label>
              </div>
            </v-flex>
            <v-flex v-for="resposta in itemVisualizando.respostas" :key="resposta.id"
                    xs12 sm12 md12 lg12 class="pb-2">
              <div class="resposta-esc-imp">
                <div class="horario-resp">
                  <div class="destaque">
                    <v-icon size="20px">schedule</v-icon>
                    <span>
                      {{resposta.dataCadastro | az-date('DD/MM/YYYY HH:mm')}}
                    </span>
                  </div>
                </div>
                <div class="conteudo-resposta">
                  <v-icon size="20px">comment</v-icon>
                  <span class="conteudo-texto">
                    {{resposta.resposta}}
                  </span>
                </div>
                <div class="anexos-resposta-esc-imp">
                  <v-icon size="20px">attach_file</v-icon>
                  <a v-if="resposta.anexoUri" :href="criarLinkDownload(resposta.anexoUri)" class="anexo-resposta az-action-link-icon" target="_blank"
                     @click="verificarUriAnexo(resposta.arquivoUri)">
                    {{resposta.anexoNome ? resposta.anexoNome  : 'Anexo'}} <v-icon size="20px">download</v-icon>
                  </a>
                  <span v-else> Nenhum anexo inserido</span>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 v-if="itemVisualizando.respostas < 1 || !itemVisualizando.respostas"
                    class="mensagem-sem-resposta-esc-ipm">
              <v-icon size="20">info</v-icon>
              <span v-if="itemVisualizando.tipo === 'ESCLARECIMENTO'">
                Este esclarecimento ainda não foi respondido
              </span>
              <span v-else>
                Esta impugnação ainda não foi respondida
              </span>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {situacoesEsclarecimentoImpugnacao} from '@/core/constants'
export default {
    name: 'ModalVisualizarEsclarecimentoImpugnacao',
    props: {
        itemVisualizando: {
            type: Object,
            default: null
        },
        maxWidth: {
            type: String,
            default: '800'
        },
    },
    data() {
        return {
            situacoesEsclarecimentoImpugnacao
        }
    },
    methods: {
        fecharModal() {
            this.$emit('fecharModal')
        },
        verificarUriAnexo(uri){
            if (!uri) {
                this.mostrarNotificacaoErro('Link para download não disponível!')
            }
        },
    }
}
</script>

<style lang="stylus">

.max-percent
  max-width 90%

.tabulacao-content
  margin-left 10px

.modal-title
  margin: 0
  padding: 10px 20px
  font-size: 18px !important
  color: white

.actions-modal
  border-top solid thin rgba(0, 0, 0, .12)
  padding-top 10px
  margin-top 0

&-conteudo
  min-height 350px

.container-header-text
  display flex
  flex-direction row
  justify-content center
  align-items center

.text-campo
  margin 0
  font-size 14px
  font-weight bold
  color #3A6861 !important

.textarea-conteudo-recurso
  padding-top 0 !important

  textarea
    padding 5px !important
    color #777 !important

  .v-input__slot
    border 1px solid #CCCCCC
    border-radius 5px

.select-analise
  margin 0 !important
  padding-top 0 !important
  .v-select__selections
    color #777 !important

.label
  font-size 14px
  font-weight bold
  color #3A6861 !important

.texto
  font-size 14px
  color #777 !important

.link-sem-decoracao a, a:link, a:hover, a:visited, a:active
  color: inherit
  text-decoration: none

.card-text-visualizar-esc-imp > div:not(:last-child)
  padding-bottom 15px

.horario-resp
  //background-color: #bebebe
  //display inline-block
  //border-top-right-radius 5px
  //border-top-left-radius 5px
  //padding-right 5px
  //padding-left 5px

  .destaque
    //transform: scale(0.9);
    font-size 5px !important
    //display inline-block
    //margin 5px
    padding 3px
    //border-radius 5px
    border-top-right-radius 5px
    border-top-left-radius 5px
    background-color: #d5d5d5

.resposta-esc-imp
  padding 5px
  background-color: #818181
  border-top-left-radius 5px
  border-top-right-radius 5px
  border-bottom-left-radius 5px
  border-bottom-right-radius 5px

  .conteudo-resposta
    //border-radius 5px
    //margin-top 10px
    padding 3px
    background-color #d5d5d5

  .anexos-resposta-esc-imp
    padding 3px
    background-color #d5d5d5
    border-bottom-left-radius 5px
    border-bottom-right-radius 5px

    .anexo-resposta
      background-color #ffffff
      border-radius 5px
      padding-left 5px
      padding-right 5px
      margin-top 5px
      margin-bottom 5px
      margin-left 3px
      margin-right 3px
      display inline-block
      color inherit

    .anexo-resposta:hover
      box-shadow 0 0 5px 1px #7f7f7f


.anexos-esc-imp
  //background-color #d5d5d5
  border-bottom-left-radius 5px
  border-bottom-right-radius 5px

  .anexo-esc-imp
    background-color #b0b0b0
    border-radius 5px
    padding-left 5px
    padding-right 5px
    margin-top 5px
    display inline-block
    color inherit

  .anexo-esc-imp:hover
    box-shadow 0 0 4px 1px #c9c9c9

.mensagem-sem-resposta-esc-ipm
  font-weight bold
  margin-top 4px
  padding-top 10px
  padding-bottom 10px
  text-align center
  background-color #cecece
  border-radius 5px

.sem-anexos-esc-ipm
  font-weight bold
  margin-top 4px
  padding-top 5px
  padding-bottom 5px
  text-align center
  background-color #cecece
  border-radius 5px
</style>